<template>
  <b-form-select
    :options="lineSelectOptions"
    :value="currentLine"
    @input="selectLine"
  />
</template>

<script>
  import {
    mapActions,
    mapGetters,
    mapState
  } from "vuex";

  export default {
    name: "LineSelect",
    computed: {
      ...mapState('mobile', [
        'currentLine'
      ]),
      ...mapGetters('mobile', [
        'lineSelectOptions'
      ])
    },
    methods: {
      ...mapActions('mobile', [
        'selectLine'
      ])
    },
  }
</script>

